import { Lightbulb } from "lucide-react";

import Spinner from "@/app/components/Spinner.jsx";
import { Button } from "@/app/components/ui/button";

interface JobCTASectionProps {
	explainerIsLoading: boolean;
	roleExplanations: unknown | null;
	onRoleExplainer: () => void;
}

export function JobActionButtons({ explainerIsLoading, roleExplanations, onRoleExplainer }: JobCTASectionProps) {
	const hasExplanation = roleExplanations !== null;

	// Only show Role Explainer CTA (FitCheck CTA is shown in FitCheckSection after role explainer)
	return (
		<div className="space-y-4 mb-8">
			<div className="bg-gradient-to-r from-primary-50 to-blue-50 rounded-xl p-5 border border-primary-100">
				<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
					<div className="flex-1">
						<h3 className="text-lg font-semibold text-gray-900 mb-1">
							{hasExplanation ? "Role explained" : "Want a clearer picture of this role?"}
						</h3>
						<p className="text-sm text-gray-600">
							{hasExplanation
								? "Scroll down to see the explanation, or generate a fresh one."
								: "Get a clear, simple explanation of what this job really involves."}
						</p>
					</div>
					<Button onClick={onRoleExplainer} disabled={explainerIsLoading} size="sm">
						{explainerIsLoading ? (
							<div className="flex items-center gap-2">
								<span className="w-4 h-4">
									<Spinner />
								</span>
								<span>Explaining...</span>
							</div>
						) : (
							<span className="flex items-center gap-2">
								<Lightbulb className="h-4 w-4" />
								{hasExplanation ? "Refresh explanation" : "Explain this role for me"}
							</span>
						)}
					</Button>
				</div>
			</div>
		</div>
	);
}
